
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-watch/video-streaming/apple-airplay",
      function () {
        return require("private-next-pages/how-to-watch/video-streaming/apple-airplay/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-watch/video-streaming/apple-airplay"])
      });
    }
  